export default __webpack_public_path__ + "static/media/bonus-04.db022a5b.png";